export interface ElevationPoint {
  day: number;
  maxElevation: number; // meters
  label?: string; // key landmark at peak elevation
}

// Only include destinations with meaningful altitude variation
export const elevationDataMap: Record<number, ElevationPoint[]> = {
  1: [ // 川藏線 成都→拉薩
    { day: 1, maxElevation: 620, label: "雅安" },
    { day: 2, maxElevation: 4298, label: "折多山口" },
    { day: 3, maxElevation: 3460, label: "新都橋" },
    { day: 4, maxElevation: 4659, label: "高爾寺山" },
    { day: 5, maxElevation: 3900, label: "芒康" },
    { day: 6, maxElevation: 4448, label: "業拉山口" },
    { day: 7, maxElevation: 3950, label: "然烏湖" },
    { day: 8, maxElevation: 3100, label: "林芝" },
    { day: 9, maxElevation: 5013, label: "米拉山口" },
    { day: 10, maxElevation: 3650, label: "拉薩" },
  ],
  2: [ // 青海湖環線
    { day: 1, maxElevation: 2200, label: "西寧" },
    { day: 2, maxElevation: 3205, label: "茶卡鹽湖" },
    { day: 3, maxElevation: 3320, label: "黑馬河日出點" },
    { day: 4, maxElevation: 3200, label: "二郎劍" },
    { day: 5, maxElevation: 2200, label: "西寧" },
  ],
  3: [ // 獨庫公路
    { day: 1, maxElevation: 450, label: "獨山子" },
    { day: 2, maxElevation: 3000, label: "天山達坂" },
    { day: 3, maxElevation: 2200, label: "喬爾瑪" },
    { day: 4, maxElevation: 1100, label: "庫車古城" },
    { day: 5, maxElevation: 1200, label: "溫宿大峽谷" },
    { day: 6, maxElevation: 900, label: "輪臺" },
    { day: 7, maxElevation: 900, label: "庫爾勒" },
    { day: 8, maxElevation: 900, label: "烏魯木齊" },
  ],
  5: [ // 雲南環線
    { day: 1, maxElevation: 2090, label: "大理" },
    { day: 2, maxElevation: 2090, label: "洱海" },
    { day: 3, maxElevation: 2400, label: "麗江" },
    { day: 4, maxElevation: 4506, label: "玉龍雪山" },
    { day: 5, maxElevation: 3160, label: "香格里拉" },
    { day: 6, maxElevation: 3700, label: "普達措" },
    { day: 7, maxElevation: 3000, label: "梅里遠眺" },
  ],
  12: [ // 西藏珠峰 拉薩環線
    { day: 1, maxElevation: 3650, label: "拉薩" },
    { day: 2, maxElevation: 3650, label: "布達拉宮" },
    { day: 3, maxElevation: 4441, label: "羊卓雍措" },
    { day: 4, maxElevation: 3836, label: "日喀則" },
    { day: 5, maxElevation: 4700, label: "薩迦縣" },
    { day: 6, maxElevation: 5200, label: "珠峰大本營" },
    { day: 7, maxElevation: 5200, label: "珠峰日出" },
    { day: 8, maxElevation: 2800, label: "吉隆溝" },
    { day: 9, maxElevation: 3836, label: "日喀則" },
    { day: 10, maxElevation: 3650, label: "拉薩" },
    { day: 11, maxElevation: 3650, label: "色拉寺" },
    { day: 12, maxElevation: 3650, label: "返程" },
  ],
  13: [ // 九寨溝
    { day: 1, maxElevation: 500, label: "成都" },
    { day: 2, maxElevation: 2500, label: "五花海" },
    { day: 3, maxElevation: 2500, label: "樹正群海" },
    { day: 4, maxElevation: 3100, label: "長海" },
    { day: 5, maxElevation: 500, label: "成都" },
  ],
  14: [ // 新疆喀納斯
    { day: 1, maxElevation: 470, label: "布爾津" },
    { day: 2, maxElevation: 1374, label: "喀納斯湖" },
    { day: 3, maxElevation: 1500, label: "觀魚台" },
    { day: 4, maxElevation: 1200, label: "禾木村" },
    { day: 5, maxElevation: 1050, label: "白哈巴" },
    { day: 6, maxElevation: 800, label: "布爾津" },
    { day: 7, maxElevation: 800, label: "烏魯木齊" },
  ],
  17: [ // 川西秘境 稻城亞丁
    { day: 1, maxElevation: 500, label: "成都" },
    { day: 2, maxElevation: 4298, label: "折多山" },
    { day: 3, maxElevation: 4014, label: "理塘" },
    { day: 4, maxElevation: 4500, label: "鹽井達坂" },
    { day: 5, maxElevation: 4448, label: "業拉山口" },
    { day: 6, maxElevation: 3950, label: "然烏湖" },
    { day: 7, maxElevation: 3100, label: "林芝" },
    { day: 8, maxElevation: 5013, label: "米拉山口" },
    { day: 9, maxElevation: 3650, label: "拉薩" },
  ],
  18: [ // 甘南藏區
    { day: 1, maxElevation: 1500, label: "蘭州" },
    { day: 2, maxElevation: 2920, label: "拉卜楞寺" },
    { day: 3, maxElevation: 2900, label: "扎尕那" },
    { day: 4, maxElevation: 3050, label: "郎木寺" },
    { day: 5, maxElevation: 3500, label: "若爾蓋" },
    { day: 6, maxElevation: 3500, label: "尕海湖" },
    { day: 7, maxElevation: 1500, label: "蘭州" },
  ],
};
